/**
 * The type of entity
 */
export enum EntityType {
  /**
   * Shared by, typical of, or relating to a whole group of similar things, rather than to any particular thing
   */
  Generic = 'generic',

  /**
   * Tech Company, like Sioslife
   */
  TechCompany = 'tech-company',

  /**
   * Insurance Company
   */
  InsuranceCompany = 'insurance-company',

  /**
   * Institution
   */
  Institution = 'institution',

  /**
   * Day Care Center
   */
  DayCareCenter = 'day-care-center',

  /**
   * Home Support
   */
  HomeSupport = 'home-support',

  /**
   * A simple and beautiful Family
   */
  Family = 'family',
}
